import React from "react";
import { GlobeIcon } from "lucide-react";
type CurrencyNoteProps = {
  tone?: "light" | "dark";
};
export function CurrencyNote({
  tone = "dark"
}: CurrencyNoteProps) {
  const dark = tone === "dark";
  return <p className={`mx-auto flex max-w-xl items-start justify-center gap-2 text-center text-sm ${dark ? "text-white/80" : "text-ink-soft"}`} data-id="element-138" data-mp="194m3gr3dvavv">
      <GlobeIcon className={`mt-0.5 h-4 w-4 shrink-0 ${dark ? "text-accent" : "text-navy-700"}`} aria-hidden="true" data-id="element-139" data-mp="1057ddsr4p2bw" />
      <span data-id="element-140" data-mp="146syg1dtgmx6">
        <strong className={dark ? "text-white" : "text-ink"} data-id="element-141" data-mp="147luo8f5fu12">Automatic currency conversion:</strong> your local price is
        calculated automatically at checkout according to your country.
      </span>
    </p>;
}